import { useTranslation } from 'react-i18next';
import { ReactComponent as PathGreen } from '~/assets/svg/PathGreen.svg';
import { ReactComponent as PathRed } from '~/assets/svg/PathRed.svg';

export const ProgressArrow = ({
  previous,
  totalNumber,
}: {
  previous: number;
  totalNumber: number;
}) => {
  const rateChange = Math.abs(totalNumber / previous - 1);
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const [t] = useTranslation('consumer_stats');

  if (previous === totalNumber) {
    return null;
  } else if (totalNumber < previous) {
    return (
      <div className="flex flex-row gap-2">
        <PathRed
          className="mt-1 h-[10px] w-[18px] text-current"
          aria-label="pathred"
        />
        <span className="ml-1 text-[12px] font-semibold text-[#F93C65]">
          {formatter.format(rateChange)} {t('decline_week')}
        </span>
      </div>
    );
  } else {
    return (
      <div className="flex flex-row gap-4">
        <PathGreen
          className="mt-2 h-[10px] w-[18px] text-current"
          aria-label="PathGreen"
        />
        <span className="ml-1 text-[12px] font-semibold text-[#2BCC93]">
          {formatter.format(rateChange)} {t('increase_week')}
        </span>
      </div>
    );
  }
  //   return (
  //     <div>
  //       <img src={PathGreen} className="mt-2 h-[10px] w-[18px]" alt="PathGreen" />
  //       <img src={PathRed} className="mt-1 h-[10px] w-[18px]" alt="pathred" />
  //     </div>
  //   );
};
